<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 2C15.3137 2 18 4.68629 18 8V16C18 19.3137 15.3137 22 12 22C8.68629 22 6 19.3137 6 16V8C6 4.68629 8.68629 2 12 2ZM12 4C9.79086 4 8 5.79086 8 8V16C8 18.2091 9.79086 20 12 20C14.2091 20 16 18.2091 16 16V8C16 5.79086 14.2091 4 12 4ZM12 7C12.5523 7 13 7.44772 13 8V10C13 10.5523 12.5523 11 12 11C11.4477 11 11 10.5523 11 10V8C11 7.44772 11.4477 7 12 7Z"
    fill="currentColor"
  />
</svg>
